import { render, staticRenderFns } from "./StaffAssignVuetifyModal.vue?vue&type=template&id=b796bd70&scoped=true"
import script from "./StaffAssignVuetifyModal.vue?vue&type=script&lang=js"
export * from "./StaffAssignVuetifyModal.vue?vue&type=script&lang=js"
import style0 from "./StaffAssignVuetifyModal.vue?vue&type=style&index=0&id=b796bd70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b796bd70",
  null
  
)

export default component.exports